var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2997 7.38867H14.9664V9.36666H18.2997C19.2913 9.36666 20.0604 9.87269 20.0604 10.3085V19.0799C20.0604 19.5154 19.2913 20.0221 18.2997 20.0221H5.69958C4.70828 20.0221 3.93917 19.5154 3.93917 19.0799V10.3095C3.93917 9.87368 4.70828 9.36732 5.69958 9.36732H9.03249V7.38933H5.69958C3.60324 7.38933 1.96118 8.67206 1.96118 10.3095V19.0802C1.96118 20.718 3.60324 22.0001 5.69958 22.0001H18.3003C20.396 22.0001 22.0387 20.7173 22.0387 19.0802V10.3095C22.0384 8.6714 20.3964 7.38867 18.2997 7.38867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9926 11.523C14.8626 11.5229 14.734 11.5485 14.614 11.5983C14.494 11.6481 14.385 11.7211 14.2933 11.8131L13.0551 13.051V2.98899C13.0551 2.7267 12.9509 2.47514 12.7654 2.28967C12.58 2.1042 12.3284 2 12.0661 2C11.8038 2 11.5523 2.1042 11.3668 2.28967C11.1813 2.47514 11.0771 2.7267 11.0771 2.98899V13.1176L9.77199 11.8128C9.68033 11.7207 9.57137 11.6476 9.45138 11.5977C9.33139 11.5478 9.20272 11.5221 9.07277 11.5221C8.94282 11.5221 8.81415 11.5478 8.69415 11.5977C8.57416 11.6476 8.4652 11.7207 8.37355 11.8128C8.28168 11.9046 8.20879 12.0135 8.15906 12.1335C8.10934 12.2534 8.08374 12.382 8.08374 12.5118C8.08374 12.6417 8.10934 12.7703 8.15906 12.8902C8.20879 13.0102 8.28168 13.1191 8.37355 13.2109L11.3264 16.1637C11.4181 16.2556 11.527 16.3284 11.6469 16.378C11.7669 16.4276 11.8954 16.4531 12.0252 16.4528H12.0401C12.2933 16.4528 12.5458 16.3569 12.739 16.1637L15.6918 13.2109C15.8304 13.0728 15.9249 12.8965 15.9633 12.7046C16.0016 12.5127 15.9821 12.3137 15.9072 12.1329C15.8323 11.9521 15.7054 11.7976 15.5425 11.689C15.3797 11.5804 15.1883 11.5227 14.9926 11.523Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.cb32401203d2d0d40d90cea4ba4ce5a7.svg";
export { ForwardRef as ReactComponent };